<template src="./btn-adicionar-no-carrinho.html"></template>
<style lang="less" src="./btn-adicionar-no-carrinho.less" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
const CarrinhoDeCompras = 'CarrinhoDeCompras'

    export default {
        props: {
            produto: {
                    default: null
            },
            customType: {
                type: String,
                required: false
            },
            customValue: {
                type: String, 
            }
        },
        computed: {
            ...mapState(CarrinhoDeCompras, ['produtos'])
        },
        methods: {
            ...mapActions(CarrinhoDeCompras, ['adicionarProdutoAoCarrinho']),
            
            adicionarProdutoNoCarrinho(produtoParametro){
                this.adicionarProdutoAoCarrinho({produto: produtoParametro});
            }
        }
    }
</script>